import {Dialog} from '@ui/overlays/dialog/dialog';
import {DialogHeader} from '@ui/overlays/dialog/dialog-header';
import {Trans} from '@ui/i18n/trans';
import {DialogBody} from '@ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {DialogFooter} from '@ui/overlays/dialog/dialog-footer';
import {Button} from '@ui/buttons/button';
import {Skeleton} from '@ui/skeleton/skeleton';
import React, {Fragment, useState} from 'react';
import {ResponseDownload, useDownload} from '@app/liens/use-download';
import {SectionHelper} from '@common/ui/other/section-helper';
import {ErrorIcon} from '@ui/icons/material/Error';
import {User} from '@ui/types/user';
import TurnstileWidget from './turnstile-widget';
import {Link} from 'react-router-dom';
import {Lien} from '@app/titles/models/lien';
import {FormattedRelativeTime} from '@ui/i18n/formatted-relative-time';
import {UpdateIcon} from '@ui/icons/material/Update';
import {Tooltip} from '@ui/tooltip/tooltip';
import {CheckCircleIcon} from '@ui/icons/material/CheckCircle';

interface LienIdDialogProps {
  id: number;
  user?: User;
}

export function DownloadDialog({id, user}: LienIdDialogProps) {
  const {close} = useDialogContext();
  const [token, setToken] = useState('');

  const handleCaptchaVerify = (token: string) => {
    setToken(token);
  };

  const importItem = useDownload(
    id,
    !!(user?.IsPremium || token?.length),
    user,
    token,
  );

  return (
    <Dialog size={'2xl'}>
      <DialogHeader>
        <Trans message={user?.IsPremium ? 'Premium Download' : 'Download'} />
      </DialogHeader>
      <DialogBody>
        {!user?.IsPremium && !token ? (
          <TurnstileWidget onVerify={handleCaptchaVerify} />
        ) : (
          <div className="overflow-hidden overflow-ellipsis">
            {importItem.data ? (
              download({data: importItem.data, user})
            ) : (
              <Skeleton />
            )}
          </div>
        )}
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => close()}>
          <Trans message="Close" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}

function download({data, user}: {data: ResponseDownload; user?: User}) {
  const alert = ({message}: {message: string}) => (
    <SectionHelper
      leadingIcon={<ErrorIcon size="xs" className="text-danger" />}
      description={message}
      title={'Erreur de Débridage'}
      color="neutral"
    />
  );
  const ButtonDownload = ({
    link,
    directDl,
  }: {
    link: Lien;
    directDl?: string;
  }) => (
    <div className="mt-24 flex h-full flex-auto items-center gap-18 overflow-x-scroll whitespace-nowrap rounded-panel border p-20">
      <div className="flex-shrink-0 rounded-lg bg-primary-light/20 p-10 text-primary">
        <Link to={directDl || link.lien} target="_blank">
          <svg
            aria-hidden="true"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            data-testid="Icon"
            className="svg-icon icon-lg"
            height="1em"
            width="1em"
          >
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"></path>
          </svg>
        </Link>
      </div>
      <div className="flex-auto">
        <div className="flex items-center justify-between gap-20">
          <div className="text-lg font-bold text-main">
            <div></div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-20">
          <h2 className="text-sm text-muted">
            <Trans message={'By'} /> {link.id_user}
          </h2>
          <div className="flex items-center gap-10">
            <Tooltip label={<Trans message={'Last checked'} />}>
              <div className="text-sm font-semibold text-muted">
                <CheckCircleIcon size={'sm'} className={'mb-3 mr-3'} />
                <FormattedRelativeTime date={link.checked_date} />
              </div>
            </Tooltip>
            <Tooltip label={<Trans message={'Last update'} />}>
              <div className="text-sm font-semibold text-muted">
                <UpdateIcon size={'sm'} className={'mb-3 mr-3'} />
                <FormattedRelativeTime date={link.updated_at} />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
  if (data.debrided) {
    return (
      <Fragment>
        <ButtonDownload link={data.lien} directDl={data.directDL} />
      </Fragment>
    );
  } else if (user?.IsPremium && !data.debrided) {
    return (
      <Fragment>
        {data.error && alert({message: data.error})}
        <ButtonDownload link={data.lien} />
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        {/*    <div className=" items-center ">
          <div>
            <img src={'/images/tuto_dl.png'} alt="tuto" />
          </div>
          <div className="text-md mt-14  text-center text-main">
            <span className={'text-muted'}>
              Dans le but de sécuriser les liens des uploaders et de prévenir
              toute utilisation abusive par des robots, les membres gratuits
              doivent désormais passer par un site intermédiaire pour récupérer
              le lien de téléchargement. Nous nous excusons pour tout
              désagrément occasionné et vous remercions de votre compréhension.
            </span>
            <br />
            <br />
            <span className={'text-xl font-bold text-main'}>
              Si vous êtes un débutant, vous pouvez consulter notre tutoriel :
              <br />
              <a
                target={'_blank'}
                href={
                  'https://darkiworld.wiki/hc/articles/7/15/84/telecharger-sur-darkiworld-sans-abonnement'
                }
              >
                <span className={'text-primary'}>
                  Commement télécharger sur Darkiworld sans abonnement
                </span>
              </a>
            </span>
          </div>
        </div>*/}
        <ButtonDownload link={data.lien} />
      </Fragment>
    );
  }
}
